import React from 'react';
import {useStyles} from './helper';

const CashierItem = ({item, keys}) => {
    const classes = useStyles({keys});
    const {groups, balance} = item;

    return (
        <div className={classes.root}>
            <span className={classes.groups}>{groups}</span>
            <span className={classes.balance}>
                {new Intl.NumberFormat('ru-RU').format(balance ? balance.toFixed(2) : balance)} 
            </span>
        </div>
    )
}

export default CashierItem;